import SDURenewalPricing from 'components/Basket/BasketList/SDURenewalPricing/SDURenewalPricing';

export default SDURenewalPricing;
